module.exports = __webpack_public_path__ + "static/media/29.84853bd1.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/accessoires/29.png
// module id = 1135
// module chunks = 0